import { CompanyModel } from './CompanyModel';
import { DisabledType } from './Enums';

export class CompanyCustomerModel {

    public constructor(init?: Partial<Pick<CompanyCustomerModel, keyof CompanyCustomerModel>>) {

        if (init) {
            if (init.company) {
                init.company = new CompanyModel(init.company);
            }
            if (typeof init.joinedAt === 'string') {
                init.joinedAt = new Date(init.joinedAt);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    companyId: number;
    customerId?: number;

    inviteCode: string;

    isActive = true;
    disabledType = DisabledType.None;

    createdAt: Date;
    joinedAt: Date;
    deletedAt?: Date;


    company: CompanyModel;


    get logoURL(): string {

        return this.company.logoURL;
    }

    get name(): string {

        return this.company.businessName;
    }
}
